import * as React from 'react'
import Bucket, { bucket } from './bucket'
import Stats from './stats'
import { chooseBlock } from './blocks'
import * as Grid from './grid'
import keyboard from './keyboard'

const [WIDTH, HEIGHT] = [10, 24]

// TODO make it fully functional (not using React.Compoment, but useEffect & everything pure)

interface State {
    score: number
    lines: number
    bucket: bucket
}

export default class Reactris extends React.Component<State> {
    bucket: any[][]
    block: { coords: number[][][]; shape: string }
    rotation: number
    x: number
    y: number
    divRef: React.RefObject<HTMLDivElement>
    timer: any        // number | null

    state = {
        score: 0,
        lines: 0,
        bucket: [[]]
    }

    constructor(props: Readonly<State>) {
        super(props)

        this.divRef = React.createRef()

        this.bucket = Grid.create(WIDTH, HEIGHT)
        this.state.bucket = Grid.clone(this.bucket)
    }

    componentDidMount() {
        this.newBlock()
        this.divRef.current!.focus()
    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    newBlock() {
        const linesCleared = Grid.sweep(this.bucket)
        const lines = this.state.lines + linesCleared

        const bonus = [0, 100, 300, 700, 1500]
        const score = this.state.score + bonus[linesCleared]

        this.setState({ lines, score, bucket: this.bucket })

        clearInterval(this.timer)
        this.timer = setInterval(() => this.down(), 650 - this.state.lines)

        this.block = chooseBlock()
        this.rotation = 0
        this.x = 3
        this.y = -1

        if (!this.move(0, 0, 0)) {
            clearInterval(this.timer)
            alert('Game over!')
        }
    }

    drop() {
        const score = this.state.score + (HEIGHT - this.y)
        this.setState({ score })

        clearInterval(this.timer)
        this.timer = setInterval(() => this.down(), 9)
    }

    down() {
        if (!this.move(0, 1, this.rotation)) {

            // block lands (TODO use draw(this.bucket, ...))
            this.block.coords[this.rotation].forEach(([xx, yy]) =>
                this.bucket[this.y + yy][this.x + xx] = this.block.shape)
            this.newBlock()
        }
    }

    // TODO to grid.js
    move(dx, dy, rotation) {
        const canMove = Grid.check(this.bucket, this.x + dx, this.y + dy, this.block, rotation)
        if (canMove) {
            // clear
            const bucket1 = Grid.draw(this.bucket, this.x, this.y, this.block, this.rotation, undefined)
            this.setState({ bucket: bucket1 })

            this.x += dx
            this.y += dy
            this.rotation = rotation

            // draw
            const bucket2 = Grid.draw(this.bucket, this.x, this.y, this.block, this.rotation, this.block.shape)
            this.setState({ bucket: bucket2 })
        }
        return canMove
    }

    // TODO touch
    keyDown(code) {
        const bucket = Grid.clone(this.state.bucket)

        // TODO pass bucket to move(s)
        switch (code) {
            case 'ArrowLeft': case 'KeyJ':
                this.move(-1, 0, this.rotation)
                break

            case 'ArrowUp': case 'KeyK':
                this.move(0, 0, (this.rotation + 1) % 4)
                break

            case 'ArrowRight': case 'KeyL':
                this.move(1, 0, this.rotation)
                break

            case 'Space':
                this.drop()
                break
        }
    }

    render() {
        return (
            <div onKeyDown={e => this.keyDown(e.code)} tabIndex={0} ref={this.divRef}>
                <Stats score={this.state.score} lines={this.state.lines} />
                <Bucket rows={this.state.bucket} />
            </div>
        )
    }
}
